<template>
    <va-create-layout>
        <RetrochargeEventTaxWithheldCharge-form
            :title="title"
            :item="item"
        ></RetrochargeEventTaxWithheldCharge-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
